import { render } from "./SowqPage.vue?vue&type=template&id=984197f4&scoped=true"
import script from "./SowqPage.vue?vue&type=script&lang=js"
export * from "./SowqPage.vue?vue&type=script&lang=js"

import "./SowqPage.vue?vue&type=style&index=0&id=984197f4&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-984197f4"]])

export default __exports__